import { Backdrop, Button, CircularProgress, Grid, Grid2, Typography } from "@mui/material";
import { Downloads } from "../../helper/DownloadService";
import { useState } from "react";

function DownloadPDFButtons({ buttons }) {
    const [loading, setLoading] = useState(false);
    return (
        <>
            <Backdrop sx={(theme) => ({ backgroundColor: "#fff", color: '#000', zIndex: theme.zIndex.drawer + 1 })} open={loading}
            >
                <div>
                    <CircularProgress color="inherit" />
                </div>
                <Typography variant="h4" component="div" sx={{ ml: 2 }}>
                    Downloading
                </Typography>
            </Backdrop>
            <Grid sx={{ mt: 2 }} container>
                {buttons.map(({ label, icon: Icon, ref, pdfComponent: PdfComponent, fileName, data, orientation }, index) => (
                    <Grid sx={{
                        padding: '5px', textAlign: "center", display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }} xs={6} sm={6} md={12 / buttons.length} lg={12 / buttons.length} xl={12 / buttons.length} key={index}>
                        {/* Hidden PDF Generation */}
                        <div style={{ display: 'none' }}>
                            <div ref={ref}>
                                <PdfComponent {...data}></PdfComponent>
                            </div>
                        </div>

                        {/* Button */}
                        <Button
                            onClick={() => {
                                const element = ref.current;
                                setLoading(true);
                                Downloads.GeneratePDF(element, fileName, orientation, setLoading);
                            }}
                            fullWidth
                            sx={{
                                backgroundColor: '#e96726',
                            }}
                            variant="contained"
                            color="primary"
                            startIcon={<Icon />}
                        >
                            {label}
                        </Button>
                    </Grid>
                ))}
            </Grid>
        </>
    )
}

export default DownloadPDFButtons;